export enum SiteMode {
    B2C = 0,
    B2B = 1,
    POS = 2
}
